import Dropzone from "dropzone";

window.Dropzone = Dropzone;